import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Lock, User, AlertCircle, Loader2 } from 'lucide-react';
import './hcapp.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  const { login, loading, error } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');

    if (!username.trim() || !password.trim()) {
      setLocalError('Bitte Benutzername und Passwort eingeben');
      return;
    }

    const result = await login(username, password);
    
    if (!result.success) {
      setLocalError(result.error || 'Login fehlgeschlagen');
    }
  };

  const displayError = localError || error;

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-logo">
            <Lock size={40} className="logo-icon" />
          </div>
          <h1>Handwerk Connected</h1>
          <p>Marketing Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {displayError && (
            <div className="login-error">
              <AlertCircle size={18} />
              <span>{displayError}</span>
            </div>
          )}

          <div className="input-group">
            <label htmlFor="username">
              <User size={16} />
              Benutzername
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Benutzername eingeben"
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">
              <Lock size={16} />
              Passwort
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort eingeben"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 size={18} className="spin" />
                <span>Anmelden...</span>
              </>
            ) : (
              <>
                <Lock size={18} />
                <span>Anmelden</span>
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>© {new Date().getFullYear()} Handwerk Connected</p>
          <p className="secure-badge">🔒 Sichere Verbindung</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
